import React from 'react';

import { Button } from '@components/Button';
import {
  ActionableDialog,
  ActionableDialogTitle,
  ActionableDialogContent,
  ActionableDialogActions,
} from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '予約をキャンセル',
    cancellableMessage: (no: string, type: string) => `${no}の${type}予約をキャンセルしますか？`,
    message: `お手続きが開始しましたため、キャンセルできません。
      恐れ入りますが、左下の「...」アイコンをクリックして、D2Dカスタマーセンターへご連絡ください。`.trim(),
  },
});

const useStyles = makeMuiStyles((_theme, _common) => ({}));

export const CancelBookingDialog: React.FC<CancelBookingDialogProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  if (props.cancellable) {
    const { open, onClose, onAction, no, type } = props;

    return (
      <ActionableDialog open={open} onClose={onClose}>
        <ActionableDialogTitle>{strings.title}</ActionableDialogTitle>
        <ActionableDialogContent>
          <div>{strings.cancellableMessage(no, type)}</div>
        </ActionableDialogContent>
        <ActionableDialogActions>
          <Button
            color="printable"
            size="small"
            text={formStrings.no}
            onClick={() => {
              onAction('NO');
              onClose();
            }}
          />
          <Button
            color="primary"
            size="small"
            text={formStrings.yes}
            onClick={() => {
              onAction('YES');
              onClose();
            }}
          />
        </ActionableDialogActions>
      </ActionableDialog>
    );
  }

  const { open, onClose } = props;

  return (
    <ActionableDialog open={open} onClose={onClose}>
      <ActionableDialogTitle>{strings.title}</ActionableDialogTitle>
      <ActionableDialogContent>
        <div dangerouslySetInnerHTML={{ __html: strings.message }} />
      </ActionableDialogContent>
      <ActionableDialogActions>
        <Button color="primary" size="small" text={formStrings.yes} onClick={onClose} />
      </ActionableDialogActions>
    </ActionableDialog>
  );
};

export type CancelBookingDialogProps =
  | CancelBookingDialogNonCancelalble
  | CancelBookingDialogCancelalble;
export interface CancelBookingDialogNonCancelalble {
  open: boolean;
  onClose: () => any;
  cancellable?: false;
}

export interface CancelBookingDialogCancelalble {
  open: boolean;
  onClose: () => any;
  onAction: (value: 'YES' | 'NO') => any;
  cancellable: true;
  no: string;
  type: string;
}
